import { render } from "./HomeBody3.vue?vue&type=template&id=2b784ef4&scoped=true"
import script from "./HomeBody3.vue?vue&type=script&lang=js"
export * from "./HomeBody3.vue?vue&type=script&lang=js"

import "./HomeBody3.vue?vue&type=style&index=0&id=2b784ef4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b784ef4"]])

export default __exports__